// Nova Nova Theme JS

// Cart state
window.NNCart = {
  items: [],
  open: false,

  init() {
    this.bindDrawer();
    this.refreshFromShopify();
  },

  bindDrawer() {
    document.querySelectorAll('[data-cart-trigger]').forEach(btn => {
      btn.addEventListener('click', () => this.openDrawer());
    });
    const overlay = document.getElementById('nn-cart-overlay');
    if (overlay) overlay.addEventListener('click', () => this.closeDrawer());
    const closeBtn = document.getElementById('nn-cart-close');
    if (closeBtn) closeBtn.addEventListener('click', () => this.closeDrawer());
  },

  openDrawer() {
    document.getElementById('nn-cart-overlay')?.classList.add('open');
    document.getElementById('nn-cart-drawer')?.classList.add('open');
    document.body.style.overflow = 'hidden';
    this.refreshFromShopify();
  },

  closeDrawer() {
    document.getElementById('nn-cart-overlay')?.classList.remove('open');
    document.getElementById('nn-cart-drawer')?.classList.remove('open');
    document.body.style.overflow = '';
  },

  async refreshFromShopify() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.renderCart(cart);
    } catch(e) { console.warn('Cart fetch failed', e); }
  },

  async addItem(variantId, qty = 1) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      await res.json();
      await this.refreshFromShopify();
      this.openDrawer();
    } catch(e) { console.warn('Add to cart failed', e); }
  },

  async updateItem(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await this.refreshFromShopify();
    } catch(e) { console.warn('Cart update failed', e); }
  },

  renderCart(cart) {
    const itemsEl = document.getElementById('nn-cart-items');
    const totalEl = document.getElementById('nn-cart-total');
    const badgeEl = document.getElementById('nn-cart-badge');
    const barEl = document.getElementById('nn-cart-shipping-bar');

    if (!itemsEl) return;

    const total = cart.total_price / 100;
    const count = cart.item_count;
    const freeShipThreshold = 750;

    if (badgeEl) {
      badgeEl.textContent = count;
      badgeEl.classList.toggle('show', count > 0);
    }
    if (totalEl) totalEl.textContent = '₹' + total.toFixed(0);
    if (barEl) {
      const remaining = freeShipThreshold - total;
      if (remaining <= 0) {
        barEl.textContent = '🎉 You\'ve unlocked FREE shipping!';
      } else {
        barEl.textContent = 'Add ₹' + Math.ceil(remaining) + ' more for FREE shipping!';
      }
    }

    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="nn-cart-empty">Your cart is empty.<br>Go discover something new!</div>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="nn-cart-item">
        <img class="nn-cart-item__img" src="${item.image}" alt="${item.title}">
        <div class="nn-cart-item__info">
          <div class="nn-cart-item__name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:12px;color:#888;margin-bottom:4px">${item.variant_title}</div>` : ''}
          <div class="nn-cart-item__price">₹${(item.price / 100).toFixed(0)}</div>
          <div class="nn-cart-item__qty">
            <button onclick="NNCart.updateItem('${item.key}', ${item.quantity - 1})">−</button>
            <span>${item.quantity}</span>
            <button onclick="NNCart.updateItem('${item.key}', ${item.quantity + 1})">+</button>
          </div>
        </div>
      </div>
    `).join('');
  }
};

// Cart Slider
function nnToggleCollapsible(trigger) {
  var body = trigger.nextElementSibling;
  var icon = trigger.querySelector('.nn-cart-collapsible__icon');
  var isOpen = body.classList.contains('open');
  // Close all first
  document.querySelectorAll('.nn-cart-collapsible__body').forEach(function(b) {
    b.classList.remove('open');
  });
  document.querySelectorAll('.nn-cart-collapsible__icon').forEach(function(i) {
    i.classList.remove('open');
  });
  // Open this one if it was closed
  if (!isOpen) {
    body.classList.add('open');
    icon.classList.add('open');
  }
}

function nnUpdateCartNote(value) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ note: value })
  });
}

function nnApplyDiscount() {
  var code = document.getElementById('nn-cart-discount-input').value.trim();
  var msg = document.getElementById('nn-cart-discount-msg');
  if (!code) return;
  // Shopify doesn't have a cart-level discount API —
  // we pass it to checkout as a URL parameter instead
  var checkoutBtn = document.getElementById('nn-cart-checkout-btn');
  if (checkoutBtn) {
    checkoutBtn.href = '/checkout?discount=' + encodeURIComponent(code);
    msg.textContent = 'Code applied — discount will show at checkout.';
    msg.className = 'nn-cart-discount-msg success';
  }
}
// Add to cart buttons on collection/homepage
document.addEventListener('click', function(e) {
  const btn = e.target.closest('[data-add-to-cart]');
  if (btn) {
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (variantId) {
      btn.textContent = '✓';
      btn.style.background = 'var(--nn-teal)';
      NNCart.addItem(variantId);
      setTimeout(() => {
        btn.textContent = '+';
        btn.style.background = '';
      }, 1200);
    }
  }
});

// Mobile nav toggle
document.addEventListener('DOMContentLoaded', function() {
  const toggle = document.getElementById('nn-mobile-toggle');
  const mobileMenu = document.getElementById('nn-mobile-menu');
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
    });
  }
  NNCart.init();
});

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', function(e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});
